import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../shared/store/views/entityView";
import { addedByUserToolsFiltersForSchool, filterToolsForTeachers, filterToolsForStudents } from "../../../shared/utils/entitiesFiltersUtils";
import { mapToolsForDisplay } from "../../../shared/utils/toolDisplayUtils";
import { usePermission } from "../../../shared/hooks/usePermission";
import { deleteToolThunk } from "../../../shared/store/redux/tool-actions";
import ToolsList from "../../../shared/components/features/toolsList/ToolsList";
import ToolAddOrUpdatePopup from "../../../shared/components/features/toolsList/toolAddOrUpdatePopup/ToolAddOrUpdatePopup";
import ViewAllToolsPopup from "./viewAllToolsPopup/ViewAllToolsPopup";
import Button from "../../../shared/components/ui/buttons/Button";
import Icon from "../../../shared/components/ui/icons/Icon";
import iconsList from "../../../shared/components/ui/icons/iconsList";
import sourceToolTypeEnum from "../../../shared/enums/sourceToolTypeEnum";
import toolLevelType from "../../../shared/enums/toolLevelType";
import classes from "./UsefulToolsPage.module.css";

const UsefulToolsPage = () => {

    const { lang, texts } = useSelector(state => state.translate);
    const schoolId = useSelector(state => state.auth.userDetails?.defaultSchool?.id);
    const [popupTool, setPopupTool] = useState(null);
    const [showViewAllPopup, setShowViewAllPopup] = useState(false);
    const toolsFilters = useMemo(() => addedByUserToolsFiltersForSchool(schoolId), [schoolId]);
    const addedByUserTools = useSelector(state => selectEntitiesByFilters(state, toolsFilters));
    const dispatch = useDispatch();
    const hasPermission = usePermission();
    const userTools = mapToolsForDisplay(addedByUserTools?.filter(t => hasPermission(t.visibleTo)), lang);

    const handleDelete = (tool) => {
        dispatch(deleteToolThunk(tool));
    };

    return (
        <div className={classes.UsefulToolsPage}>
            <div className={classes.Header}>
                <p className={classes.Title}>{texts.addEnvironments}</p>
                <Button
                    className={classes.AddToolBtn}
                    onClick={() => setPopupTool({})}
                    accessibilityDescription={texts.addToolBtn}
                >
                    <Icon name={iconsList.addCircleButton} size="20px" color="white" />
                    <span>{texts.addToolBtn}</span>
                </Button>
            </div>
            <ToolsList
                text={texts.toolsForTeachers}
                tools={filterToolsForTeachers(userTools)}
                onEdit={(tool) => setPopupTool(tool)}
                onDelete={handleDelete}
            />
            <ToolsList
                text={texts.toolsForStudents}
                tools={filterToolsForStudents(userTools)}
                onEdit={(tool) => setPopupTool(tool)}
                onDelete={handleDelete}
            />
            <div className={classes.AdditionalSection}>
                <p className={classes.AdditionalTitle}>{texts.additionalSystemTools}</p>
                <Button className={classes.ViewAllBtn} onClick={() => setShowViewAllPopup(true)}>
                    {texts.viewAllTools}
                </Button>
            </div>
            {popupTool !== null &&
                <ToolAddOrUpdatePopup
                    tool={popupTool}
                    onClose={() => setPopupTool(null)}
                    sourceTypeId={sourceToolTypeEnum.Manager}
                    toolLevel={toolLevelType.School}
                />
            }
            {showViewAllPopup && (
                <ViewAllToolsPopup onClose={() => setShowViewAllPopup(false)} />
            )}
        </div>
    );
};

export default UsefulToolsPage;
